export function generateEmailBody(obj: { [key: string]: string | undefined }): string {
	let result = '';

	Object.entries(obj).forEach(([label, value]) => {
		result += `${label.charAt(0).toUpperCase() + label.slice(1)}: ${value ?? ''}\n\n`;
	});

	return result;
}
